<template>
  <div>
    <b-row class="mb-2" v-if="displayButton">
      <b-col class="text-center">
        <verification-user-email ref="verificationUserAlert"
                                 placement="bottomleft"
                                 target="new-entity-button"/>
        <b-button @click="showModal = $refs.verificationUserAlert.isVerified"
                  class="btn-anchor raised" id="new-entity-button">
          + Add New Entity</b-button>
      </b-col>
    </b-row>
    <b-modal
      id="new-entity-modal"
      v-model="showModal"
      header-class="anchor-modal"
      footer-bg-variant="light"
      ref="newEntityModal"
      title="Create a New Entity"
      @keyup.enter.native="saveEntity"
    >
      <b-row>
        <b-col>
          <vue-form-generator
            :schema="schema.schema"
            :model="model"
            :options="schema.options"
            ref="newEntityForm"
          />
          <hr/>
          <address-form-fields
            ref="businessAddressForm"
            placeholder="Business Address"
            :grid="grid"
            :form="model.businessAddress"
            @address-updated="model.businessAddress = $event"
          />
          <div class="col-md-12 mb-3">
            <b-form-checkbox
              id="new-entity-same-address"
              v-model="model.sameAddress"
            >
            Use the address above for mailing
          </b-form-checkbox>
          </div>
          <address-form-fields
            v-if="!model.sameAddress"
            ref="mailingAddressForm"
            placeholder="Mailing Address"
            :grid="grid"
            :form="model.mailingAddress"
            @address-updated="model.mailingAddress = $event"
          />
          <vue-form-generator
            :schema="associatedEntitiesSchema.schema"
            :model="model"
          />
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-button
          size="md"
          id="btn-save-entity"
          class="float-right btn-anchor raised"
          @click="saveEntity"
        >
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { DEFINE_ENTITIES } from '@/vuex/modules/entities/types/actions';
import helper from '@/libs/helper';

import VueFormGenerator from 'vue-form-generator';
import AddressFormFields from '@/components/utils/address/AddressFormFields';

import ENTITY_MODEL from '@/components/entities/resources/entity.json';
import ENTITY_PARTNERSHIP from '@/components/entities/resources/partnershipPerType.json';
import ENTITY_SCHEMA from '@/components/entities/schemas/entity';
import ASSOCIATED_ENTITIES_SCHEMA from '@/components/entities/schemas/associatedEntitiesSchema';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    'address-form-fields': AddressFormFields,
    VerificationUserEmail,
  },
  props: {
    displayButton: {
      type: Boolean,
      default() { return true; },
    },
  },
  data() {
    return {
      showModal: false,
      model: this.getModel(),
      schema: ENTITY_SCHEMA,
      associatedEntitiesSchema: ASSOCIATED_ENTITIES_SCHEMA,
      grid: {
        lg: { cols: 12, offset: 0 },
        md: { cols: 12, offset: 0 },
      },
    };
  },
  computed: {
    entityType() {
      return this.model.type;
    },
  },
  methods: {
    saveEntity() {
      const sameAddress = this.model.sameAddress;
      const basicDataValid = this.$refs.newEntityForm.validate();
      const bAddressValid = this.$refs.businessAddressForm.validate();
      const mAddressValid = sameAddress ?
        true : this.$refs.mailingAddressForm.validate();

      if (basicDataValid && bAddressValid && mAddressValid) {
        const data = helper.copy(this.model);
        delete data.sameAddress;
        if (sameAddress) {
          data.mailingAddress = data.businessAddress;
        }

        const user = this.$store.getters.user;
        this.$reqs.post(`/users/${user.id}/entities`, data)
          .then((response) => {
            const entities = response.data.entities;
            this.$emit('entity-added', entities[entities.length - 1]);
            this.$store.dispatch(DEFINE_ENTITIES, { entities });
            this.showModal = false;
          })
          .catch(() => {});
      }
    },
    getModel() {
      return helper.copy(ENTITY_MODEL);
    },
  },
  watch: {
    entityType(val) {
      if (val) {
        this.model.partnership = [];
        const partnership = ENTITY_PARTNERSHIP[val];
        const partnershipField = this.schema.schema.fields[this.schema.partnershipFieldIndex];
        partnershipField.options = Object.keys(partnership).map(key => ({
          id: key,
          text: partnership[key],
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/entities/NewEntity.vue